import LegalPage from './index'
import styles from './style.module.scss'

/* Inhaltlich massgeblich: Junior/rechtstexte/impressum.md (Stand August 2026). */
export default function Impressum() {
	return (
		<LegalPage title="Impressum" stand="August 2026">
			<p>
				Informationspflicht laut § 5 E-Commerce-Gesetz (ECG), § 25 Mediengesetz (MedienG) und
				Offenlegungspflicht laut § 14 Unternehmensgesetzbuch (UGB).
			</p>

			<h2>Medieninhaber und Betreiber der Plattform „Junior Datenbank"</h2>
			<address className={styles.address}>
				<strong>„Junior Achievement Austria" – Unternehmerische Praxis- und Kompetenzbildung</strong>
				<br />
				Verein, nicht auf Gewinn gerichtet
				<br />
				Heinrichsgasse 3/1/Top 8+9, 1010 Wien, Österreich
				<br />
				Telefon: <a href="tel:+4367684171755">+43 676 841 717 55</a>
				<br />
				E-Mail: <a href="mailto:info@junior.cc">info@junior.cc</a>
				<br />
				Web:{' '}
				<a href="https://www.junior.cc" target="_blank" rel="noopener noreferrer">
					www.junior.cc
				</a>
				<br />
				ZVR-Zahl: 252077520
				<br />
				Vereinsbehörde: Landespolizeidirektion Wien, Referat Vereins-, Versammlungs- und
				Medienrechtsangelegenheiten
			</address>

			<h3>Präsidium</h3>
			<ul>
				<li>
					Ing. Mag. Herwig Draxler (Vorsitzender; Geschäftsführer Volkswirtschaftliche Gesellschaft Kärnten)
				</li>
				<li>Carmen Goby (Vorsitzenden-Stellvertreterin; Wirtschaftskammer Österreich)</li>
				<li>Verena Eugster (Vorsitzenden-Stellvertreterin; Bundesvorsitzende der Jungen Wirtschaft)</li>
			</ul>

			<h3>Vorstand</h3>
			<ul>
				<li>
					Ing.in Julia Lauss, MEd, BEd (Geschäftsführerin Volkswirtschaftliche Gesellschaft Oberösterreich)
				</li>
				<li>Karin Streimetweger (Geschäftsführerin Volkswirtschaftliche Gesellschaft Niederösterreich)</li>
				<li>
					Mag. Melina Schneider (Leiterin der Abteilung für Bildungspolitik, Wirtschaftskammer Österreich)
				</li>
				<li>Dr. Michaela Marterer (Geschäftsführerin Steirische Volkswirtschaftliche Gesellschaft)</li>
				<li>Christoph Laubner, MSc. (Geschäftsführer Volkswirtschaftliche Gesellschaft Burgenland)</li>
				<li>Lukas Oppermann, BA (Geschäftsführer Volkswirtschaftliche Gesellschaft Wien)</li>
				<li>Mag. Michael Otter (Leiter AUSSENWIRTSCHAFT AUSTRIA, Wirtschaftskammer Österreich)</li>
				<li>Lukas Mang, MA (Geschäftsführer Volkswirtschaftliche Gesellschaft Salzburg)</li>
				<li>Mag. Markus Abart (Volkswirtschaftliche Gesellschaft Tirol)</li>
				<li>Mag. Beatrice Winkler (Geschäftsführerin Vorarlberger Volkswirtschaftliche Gesellschaft)</li>
			</ul>

			<h2>Vereinszweck und grundlegende Richtung (Blattlinie gemäß § 25 MedienG)</h2>
			<p>Der Vereinszweck lautet nach den Vereinsstatuten:</p>
			<blockquote className={styles.quote}>
				Der Verein, dessen Tätigkeit nicht auf Gewinn gerichtet ist, bezweckt die Förderung von
				unternehmerischem Denken und Handeln sowie das Interesse an Wirtschaft von Jugendlichen und
				Schüler*innen. Das soll vor allem dadurch geschehen, dass Schüler*innen im Rahmen ihrer Schulausbildung
				die Möglichkeit geboten wird, für einen begrenzten Zeitraum in einem Junior Unternehmen bzw. einem
				Programm von Junior Achievement Austria unternehmerisch tätig zu sein. Der Verein hat die Aufgabe, durch
				die Partnerschaft von Wirtschaft und Schule Einblick in die Arbeits- und Wirtschaftswelt zu ermöglichen.
				Eine weitere Aufgabe ist die Pflege von Kontakten mit allen relevanten Einrichtungen in- und außerhalb
				Österreichs.
			</blockquote>
			<p>
				Die Plattform „Junior Datenbank" (erreichbar unter{' '}
				<a href="https://company.junior.cc">company.junior.cc</a>) dient diesem Zweck: der Verwaltung und
				Präsentation von Junior Companies (Schülerfirmen) im Rahmen der Programme von Junior Achievement Austria
				sowie der Kommunikation zwischen Schüler:innen, Lehrkräften, Unterstützer:innen und der
				Programmorganisation.
			</p>

			<h2>Betrieb und Hosting</h2>
			<address className={styles.address}>
				<strong>DaVinciLab GmbH</strong>
				<br />
				Poschgasse 3/51, 1140 Wien, Österreich
				<br />
				E-Mail: <a href="mailto:office@davincilab.at">office@davincilab.at</a>
				<br />
				Web:{' '}
				<a href="https://davincilab.at" target="_blank" rel="noopener noreferrer">
					davincilab.at
				</a>
				<br />
				Firmenbuchnummer: FN 574068v, Firmenbuchgericht: Handelsgericht Wien
				<br />
				UID-Nummer: ATU77893308
			</address>
			<p>
				Die DaVinciLab GmbH entwickelt und betreibt die Plattform im Auftrag von Junior Achievement Austria
				(Auftragsverarbeiterin im Sinne des Art. 28 DSGVO). Der Betrieb erfolgt auf Infrastruktur der Amazon Web
				Services EMEA S.à r.l., 38 Avenue John F. Kennedy, L-1855 Luxemburg, in der Region eu-central-1
				(Frankfurt am Main, Deutschland). AWS stellt ausschließlich die Infrastruktur bereit und ist
				Unterauftragsverarbeiterin.
			</p>
			<p>
				Medieninhaberin, für die Inhalte verantwortlich und Verantwortliche im Sinne der
				Datenschutz-Grundverordnung ist ausschließlich Junior Achievement Austria.
			</p>

			<h2>Verbraucherstreitbeilegung</h2>
			<p>
				Junior Achievement Austria ist weder bereit noch verpflichtet, an Streitbeilegungsverfahren vor einer
				Verbraucherschlichtungsstelle teilzunehmen.
			</p>

			<h2>Urheberrecht</h2>
			<p>
				Die Inhalte dieser Plattform (Texte, Bilder, Grafiken, Logos, Dokumente) unterliegen dem Urheberrecht.
				Jede vom Urheberrechtsgesetz nicht zugelassene Verwertung bedarf der vorherigen schriftlichen Zustimmung
				des jeweiligen Rechteinhabers. Inhalte, die von Nutzer:innen (z. B. Schülerfirmen) eingestellt wurden,
				liegen in deren Verantwortung; die Rechte daran verbleiben bei den jeweiligen Urheber:innen.
			</p>

			<h2>Haftung für Inhalte und Links</h2>
			<p>
				Die Inhalte dieser Plattform wurden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit,
				Vollständigkeit und Aktualität der Inhalte – insbesondere der von Nutzer:innen eingestellten Inhalte (z.
				B. Firmenprofile, Geschäftsideen, Berichte) – übernimmt Junior Achievement Austria keine Gewähr. Sollten
				Ihnen rechtswidrige Inhalte auffallen, ersuchen wir um Mitteilung an{' '}
				<a href="mailto:info@junior.cc">info@junior.cc</a>; diese werden nach Prüfung unverzüglich entfernt.
			</p>
			<p>
				Diese Plattform enthält Links zu externen Websites Dritter (z. B. junior.cc, davincilab.at, Websites und
				LinkedIn-Profile von Unterstützer:innen). Auf deren Inhalte hat Junior Achievement Austria keinen
				Einfluss; für diese Inhalte ist stets der jeweilige Anbieter verantwortlich. Zum Zeitpunkt der
				Verlinkung waren keine rechtswidrigen Inhalte erkennbar.
			</p>
		</LegalPage>
	)
}
